export const GROUP_LISTE_REQUETTE = "GROUP_LISTE_REQUETTE";
export const GROUP_LISTE_SUCCES = "GROUP_LISTE_SUCCES";
export const GROUP_LISTE_ECHEC = "GROUP_LISTE_ECHEC";

export const GROUP_CREATION_REQUETTE = "GROUP_CREATION_REQUETTE";
export const GROUP_CREATION_SUCCES = "GROUP_CREATION_SUCCES";
export const GROUP_CREATION_ECHEC = "GROUP_CREATION_ECHEC";

export const GROUP_DETAILS_REQUETTE = "GROUP_DETAILS_REQUETTE";
export const GROUP_DETAILS_SUCCES = "GROUP_DETAILS_SUCCES";
export const GROUP_DETAILS_ECHEC = "GROUP_DETAILS_ECHEC";
